import { getAIHighlightPositions } from '../../ui/utils/selection';
import { getPluginState as getDecoPluginState } from '../decoration/decoration-plugin-factory';
export function isPseudoSelectionChanged(oldState, newState) {
  var _getDecoPluginState, _getDecoPluginState2;
  var oldDecoSet = (_getDecoPluginState = getDecoPluginState(oldState)) === null || _getDecoPluginState === void 0 ? void 0 : _getDecoPluginState.modalDecorationSet;
  var newDecoSet = (_getDecoPluginState2 = getDecoPluginState(newState)) === null || _getDecoPluginState2 === void 0 ? void 0 : _getDecoPluginState2.modalDecorationSet;
  var oldPositions = oldDecoSet ? getAIHighlightPositions({
    modalDecorationSet: oldDecoSet
  }) : undefined;
  var newPositions = newDecoSet ? getAIHighlightPositions({
    modalDecorationSet: newDecoSet
  }) : undefined;
  if (oldPositions && !newPositions || !oldPositions && newPositions) {
    return true;
  }
  if (oldPositions && newPositions) {
    return oldPositions[0] !== newPositions[0] || oldPositions[1] !== newPositions[1];
  }
  return false;
}